module.exports = {
    product_zone_ticket: {
        info:
            "Gyldig til Midttrafiks busser, Letbanen og Midtjyske Jernbaner. Ikke gyldig i DSB og Arriva tog."
    },
    field_stop_location_from: {
        label: "Fra"
    },
    field_stop_location_via: {
        label: "Via"
    },
    field_stop_location_to: {
        label: "Til"
    },
    field_customer_name: {
        label: "For – og efternavn på den rejsende"
    },
    field_fee_number: {
        label: "Afgiftsnummer"
    },
    block_header: {
        menu: "Menu",
        privacy_policy: "Privatlivspolitik",
        to_main_page: "Til Midttrafik"
    },
    block_footer: {
        customer_center: "Midttrafik kundecenter",
        phone: "Tlf. 70 210 230",
        se_opening_hours: "Se åbningstider",
        accessibility_statement: "Tilgængelighedserklæring",
        payment_options: "Betalingsmuligheder",
        get_app: "Hent Midttrafik billetapp",
        get_app_apple: "Hent app i Apple App Store",
        get_app_google: "Hent app i Google Play Store"
    },
    block_fixedprice_product_card: {
        button: "Køb billet →"
    },
    page_new_zone_ticket: {
        title: "Køb enkeltbilletter",
        next_step_button: "Søg rejse →",
        add_via: "Tilføj viapunkt",
        goto_all_products: "Vis alle øvrige billetter →",
        airport_warning: "Kørsel med rute 925X er omfattet af specialtakst. Køb billetten i menupunktet “Køb øvrige billetter”"
    },
    page_new_fixed_price_ticket: {
        title: "Køb øvrige billetter",
        buttonBuy: "Køb billet",
        buttonFree: "Gratis billet"
    },
    page_retiree_products: {
        title: "Køb pensionistkort",
        description:
            "Hvis du er +67 år eller førtidspensionist, kan du købe et pensionistkort på pap, som er gyldigt i hele din kommune. Klik på din kommune for at læse, hvad der gælder for dig.",
        select_municipality: "Vælg kommune"
    },
    page_new_retiree_ticket: {
        title: "Køb pensionistkort",
        product_information_title: "Du er ved at købe",
        validity_span_title: "Gyldighedsperiode",
        validity_span_description:
            "Vælg hvornår dit kort skal være gyldigt fra og til. Du kan forvente op til 10 dages leveringstid <strong>(længere tid i perioder med helligdage)</strong>. Derfor kan du tidligst vælge din startdato fra om 10 dage og frem.",
        product_variant_title: "Produkt",
        next_step_button: "Fortsæt"
    },
    page_fixed_price_products: {
        title: "Køb øvrige billetter",
        description:
            "Midttrafik har særlige tilbud til dig, der skal på tur med familien, en tur fra øst til vest i Region Midtjylland eller med bus til lufthavnen i Aarhus eller Billund."
    },
    page_customer_information: {
        title: "Udfyld oplysninger",
        product_information_title: "Du er ved at købe",
        product_information_title_payment: "Du er ved at betale",
        identification_title: "Fremvisning af ID",
        identification_description:
            "Èn af de rejsende skal fremvise ID på rejsen for, at billetten er gyldig",
        identification_link: "læs hvorfor",
        contact_title: "Kundeoplysninger",
        contact_description_email:
            "Du kan både printe billetten eller fremvise din billet på din smartphone. Du får din billet tilsendt som pdf på din e-mail.",
        contact_description_snailmail:
            "Indtast venligst for- og efternavn på indehaveren af kortet neden for. Vi sender desuden en kvittering for købet på email. Derfor bedes du indtaste en email nedenfor. Hvis du ikke har en email, så lav evt. en aftale med en god ven eller familie, og udfyld dennes email neden for.",
        contact_description_controlfee: "Indtast venligst fornavn, efternavn og e-mail nedenfor. Du modtager en kvittering på din betaling af kontrolafgiften via den oplyste e-mail. Betalingen anses som gennemført, når du modtager din kvittering.",
        delivery_title: "Hvor skal vi sende dit kort hen?",
        delivery_description:
            "Vi sender dit pensionistkort med posten. Du kan forvente op til {days} dages leveringstid. Indtast dit navn og adresse nedenfor.",
        next_step_button: "Fortsæt"
    },
    page_confirm_basket: {
        title: "Godkend bestilling",
        title_payment: "Godkend betaling og betalingsvilkår",
        confirm_button_part_one: "Jeg accepterer",
        confirm_button_part_one_controlfee: "Jeg har læst og accepterer",
        confirm_button_part_two:
            "for Midttrafik webshop.",
        confirm_button_part_two_controlfee:
            "for Midttrafik kontrolafgift.",
        confirm_button_part_three: "for at gennemføre mit køb",
        confirm_button_link: "betingelserne",
        confirm_button_link_controlfee: "betalingsvilkår",
        confirm_privacy_policy_text: "Se hvordan dine personoplysninger behandles i Midttrafiks",
        confirm_button_privacy_link: "privatlivspolitik",
        delivery_terms:
            "Jeg accepterer, at Midttrafik trækker pengene fra mit betalingskort før varen er afsendt, fordi mit pensionistkort er personligt, og tilpasses med mine personlige oplysninger.",
        delivery_terms_note:
            "*Bestiller du gratis kort til Horsens, er du pt. af tekniske årsager nødt til at acceptere ovenstående. Du har dog ikke opgivet betalingskortoplysninger, og du bliver ikke trukket for noget beløb.",
        retiree_ticket_bullets: [
            "Dit nye pensionistkort er uden billede. Derfor skal du altid medbringe ID, når du rejser, dvs. pas, kørekort eller sygesikringskort.",
            "Er du førtidspensionist, skal du have dokumentation med, når du rejser, dvs. gyldig pensionsmeddelelse eller legitimationskort udstedt af DSB eller din kommune.",
            "Har du fornyet dit pensionistkort, skal du udskifte både dit stamkort og værdikort hver gang. Det sker af hensyn til kontrolkoden nederst på begge kort, som skal være identiske ved en kontrol."
        ],
        next_step_button: "Fortsæt til betaling",
        product_information_title: "Betalingskort eller Mobilepay",
        message_accept_terms: "Accepter venligst vilkår og betingelser for at fortsætte",
        message_payment_method: "Vælg betalingsmetode",
        approve_and_go_to_payment: "Godkend og gå til betaling",
        approve_and_go_to_free_payment: "Bestil gratis billet"
    },
    page_controlfee: {
        title: "Kontrolafgift",
        description: "Afgiftsnummer",
        type_your_fee_number: "Her skal du indtaste dit afgiftsnummer",
        next_step_button: "Fortsæt",
        customerinfo: {
            description: "Afgørelsen sendes til dig via digital post eller med brevpost."
        }
    },
    page_not_found: {
        description:
            "Har du brug for hjælp kan du kontakte kundeservice på +45 70 210 230."
    },
    modal_error: {
        description:
            "Prøv venligst igen, eller kontakt kundeservice på +45 70 210 230."
    },
    modal_no_trip: {
        help: "Prøv venligst igen eller kontakt kundeservice på +45 70 210 230."
    },
    modal_content_page: {
        description:
            "Har du brug for hjælp kan du kontakte kundeservice på +45 70 210 230."
    },
    product_controlfee: {
        title: "Betaling af kontrolafgift",
        description: "Du er ved at foretage betaling af kontrolafgift",
        fee: "Afgiftsnummer"
    }

};
